export const exclusivityMapping: Record<string, string> = {
  ABG: 'AUSTRALIAN BUYERS GROUP',
  BEAUMONT: 'BEAUMONT',
  BENTONS: 'BENTONS',
  BUNNINGS: 'BUNNINGS',
  CHESTERS: 'CHESTERS',
  CLIVEP: 'CLIVE PEETERS',
  CMC: 'CMC PROPERTY SERVICES PTY LTD',
  COSTCO: 'COSTCO GROUP',
  CRANE: 'CRANE GROUP',
  DANKS: 'JOHN DANKS',
  FLETCHER: 'FLETCHERS',
  HARVNSWRET: 'HARVEY NORMAN',
  HUDSON: 'HUDSON BUILDING SUPPLIES',
  M10: 'MITRE 10',
  MICO: 'MICO',
  MICOPLACE: 'MICO AND PLACEMAKERS',
  NOVER: 'NOVER & CO',
  PLUMBTEC: 'PLUMBTEC GROUP',
  PLUMWO: 'PLUMBING WORLD',
  PPLUS: 'PLUMBING PLUS',
  REECE: 'REECE',
  REIR_POOL: 'REECE IRRIGATION & POOLS',
  SOLEX: 'SOLEX',
  SYDWATER: 'SYDNEY WATER PROJECT',
  TRADECOOKS: 'TRADELINK AND COOKS PLUMBING',
  TRADELINK: 'TRADELINK',
  WINNINGS: 'WINNINGS',
};